export default {
  items: [

    {
      name: 'Tableau de Bords',
      url: '/dashboard',
      icon: 'fa fa-dashboard'
    },
    {
      name: 'Mon Dossier',
      url: '/mon-dossier',
      icon: 'fa fa-address-book'
    },
    {
      name: 'Messages',
      url: '/messages',
      icon: 'fa fa-envelope'
    },

  ]
}
